import React from "react";
import CardWithShadow from "../../common/CardWithShadow";
import HtmlElement from "../../common/HtmlElement";
import { AppContext } from "../../core/ApplicationContextProvider";
import Contact from "../../template-parts/Contact";
import "./TokenExpired.css";
import type { AppContextType } from "../../core/types";

const TokenExpired: React.FC = () => {
  const context = React.useContext(AppContext) as AppContextType;
  const { bgHook, details } = context;
  
  if (!details) {
    return <></>;
  }
  
  const { businessLineDetails, campaignDetails } = details;
  bgHook.setFixedPage();
  
  const defaultTitle =
    "Ne pare rau, campania de colectare a acordului s-a incheiat.";
  const defaultSubtitle = (
    <>
      <p className="mb-4">
        Vei primi Scrisoarea de Informare anuala aferenta anului 2020 prin
        intermediul postei, in format fizic.
      </p>
      <p>
        Totodata, incepand cu 15.05.2021, vei putea accesa Informarea anuala
        pentru 2020 si direct pe telefon, in aplicatia mobila{" "}
        <a href="https://bit.ly/nndirectapp" className="link">
          NN Direct
        </a>
        , sectiunea Documente.
      </p>
      <p>
        In cazul in care, iti vei exprima acordul prin call center sau in
        urmatoarea campanie de colectare acord pe care o vom derula, vei putea
        primi la anul Informarea anuala pentru 2021 prin e-mail.
      </p>
      <p>
        In continuare, pentru orice informatii ai nevoie, iti raspundem cu
        placere la numarul ori la adresa de e-mail trecute mai jos.
      </p>
    </>
  );

  const expiredPage = campaignDetails?.expiredPage;

  return (
    <React.Fragment>
      <div className="container pt-3 pl-0 pr-0 token-expired">
        <div className="row mt-5 mb-2 m-right-sm">
          <div className="offset-md-6 col-md-6 mt-5 pr-0 pt-1">
            <CardWithShadow>
              <div className="pt-2"></div>
              <div className="text-center p-4">
                <div
                  className="text-center pt-2 pb-2 mt-2"
                  style={{ fontSize: "1.1rem" }}
                >
                  {(expiredPage && expiredPage.title) || defaultTitle}
                </div>
                <div className="pt-4 mb-2 orange-bold">
                  {expiredPage && expiredPage.subtitle ? (
                    <HtmlElement elements={expiredPage.subtitle}></HtmlElement>
                  ) : (
                    defaultSubtitle
                  )}
                </div>
              </div>
              <div className="pt-2"></div>
            </CardWithShadow>
          </div>
        </div>
      </div>
      <div className="container m-bottom-sm pl-md-0 pr-md-0">
        <div className="row m-bottom-sm">
          <Contact
            businessLineDetails={businessLineDetails}
            campaignDetails={campaignDetails}
          />
        </div>
        <div className="row mb-5 d-none d-md-block">
          <div className="col-12 mb-5">
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TokenExpired;
